module.exports = __webpack_public_path__ + "img/image (6).af9ff96c.jpg";